import { useContext } from 'react';
import AuthContext from 'src/ui-bloom/contexts/JWTAuthContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
